export default __webpack_public_path__ + "static/media/about.f554db5a.png";